import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export const SEO = ({ 
  title, 
  description, 
  keywords, 
  image,
  url,
  type = 'website'
}) => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const siteTitle = "Pure Atelier Riga | Fine Jewelry & Engagement Rings";
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  
  const defaultDescription = lang === 'lv' 
    ? "Ekskluzīvi saderināšanās gredzeni un juvelierizstrādājumi Rīgā. Augstākās kvalitātes dimanti un rokdarbi. Pure Atelier - jūsu ideālā rotaslieta."
    : "Эксклюзивные помолвочные кольца и ювелирные изделия в Риге. Бриллианты высочайшего качества и ручная работа. Pure Atelier - ваше идеальное украшение.";
  
  const defaultKeywords = lang === 'lv'
    ? "saderināšanās gredzeni, gredzeni Riga, juvelierizstrādājumi Rīgā, dimanti Rīgā, auskari, aproces, ekskluzīvi gredzeni, Pure Atelier, laulību gredzeni, dārgi gredzeni"
    : "помолвочные кольца, кольца Рига, ювелирные изделия Рига, бриллианты Рига, серьги, браслеты, эксклюзивные кольца, Pure Atelier, обручальные кольца, дорогие кольца";

  const finalDescription = description || defaultDescription;
  const finalKeywords = keywords || defaultKeywords;
  const finalImage = image || "https://images.unsplash.com/photo-1762019313711-8b5d1e4f7ba4?w=1200&h=630&fit=crop";
  const finalUrl = url || "https://pureatelier.lv";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:locale" content={lang === 'lv' ? 'lv_LV' : 'ru_RU'} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={finalUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={finalDescription} />
      <meta property="twitter:image" content={finalImage} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <link rel="canonical" href={finalUrl} />
    </Helmet>
  );
};
